import React from 'react';
import { Loader } from '@thd-olt-component-react/core-ui';
import {
  Button,
} from '@one-thd/sui-atomic-components';

function LoadingContent() {
  return (
    <div className="sui-grid sui-grid-cols-1 sui-justify-items-center">
      <div className="sui-grid sui-grid-cols-1 sui-m-20 sui-justify-items-center">
        <Loader className="sui-grid sui-grid-cols-1 sui-justify-items-center" active />
      </div>
      <div className="sui-grid sui-grid-cols-1 sui-justify-items-center">
        <Button
          className="buttonPosition sui-inline-flex sui-items-center sui-justify-center
          sui-relative sui-box-border sui-outline-none sui-outline-0 sui-border-0
          sui-cursor-pointer sui-select-none sui-align-middle sui-appearance-none
          sui-no-underline sui-min-w-16 sui-px-4 sm:sui-px-6 sui-py-[10px] sm:sui-py-[14px]
          sui-rounded-sm sm:sui-rounded-base focus-visible:sui-bg-button-focus
          focus-visible:sui-text-primary sui-antialiased sui-font-bold sui-text-base
          sui-leading-normal sui-tracking-normal sui-normal-case  sui-line-clamp-none
          sui-w-full sm:sui-w-fit sui-bg-button-inactive-primary sui-text-inactive
          sui-pointer-events-none sui-cursor-default"
          variant="primary"
          disabled
        >
          Register
        </Button>
      </div>
    </div>
  );
}

export default LoadingContent;